// extracted by mini-css-extract-plugin
module.exports = {"title":"za-nas-module--title--18vam","bgSection":"za-nas-module--bgSection--2NWwQ","bgCoverImg":"za-nas-module--bgCoverImg--2-rmE"};